import type { FC } from "react";

import { getFlavorThumbnailSizePx } from "@ui/utils/getFlavorThumbnailSizePx";
import { getOptimizedMagentoImageSrcSet } from "@ui/utils/getOptimizedMagentoImageSrcSet";

import { useConfig } from "@jti/app-context/useConfig";

import styles from "./SelectionResultOverviewItem.module.scss";

type SelectionResultOverviewItem = {
  description?: string;
  label: string | null;
  imageUrl?: string;
  quantity: number;
};

export const SelectionResultOverviewItem: FC<SelectionResultOverviewItem> = ({
  description,
  label = "",
  imageUrl,
  quantity,
}) => {
  const { showFlavourDescriptionInFlavourSelector = false } = useConfig();
  const thumbnailSizePx = getFlavorThumbnailSizePx();

  const { optimizedImageSrc1x, optimizedImageSrcSet } = getOptimizedMagentoImageSrcSet({
    src: imageUrl,
    baseWidth: thumbnailSizePx,
    baseHeight: thumbnailSizePx,
  });

  return (
    <section className={styles.container} data-testid="selection-result-overview-item">
      <header className={styles.header}>
        <strong className={styles.headline}>
          &times;{quantity}&nbsp;{label}
        </strong>

        {showFlavourDescriptionInFlavourSelector && description && (
          <div className={styles.flavorDescription}>{description}</div>
        )}
      </header>

      {optimizedImageSrc1x ? (
        <img
          className={styles.image}
          data-testid="selection-result-overview-item-image"
          src={optimizedImageSrc1x}
          srcSet={optimizedImageSrcSet}
          alt=""
          loading="lazy"
          decoding="async"
        />
      ) : (
        <span className={styles.image} data-testid="selection-result-overview-item-image-placeholder" />
      )}
    </section>
  );
};
